import _slicedToArray from "/builds/1-Ndk5Hm/0/webservices/sites/dental-dna-cigna-com/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/builds/1-Ndk5Hm/0/webservices/sites/dental-dna-cigna-com/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { cookie } from '../util/storage';
import { getParams } from '../util/url';
import formatPhoneNumber from '../util/formatters';
export var updatePhoneNumber = function updatePhoneNumber(phoneNumber) {
  var isFormatted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var dynamicPhoneNumbers = new Set([].concat(_toConsumableArray(document.querySelectorAll('.campaign-phone-number')), _toConsumableArray(document.querySelectorAll('.ifp-phone-number'))));
  cookie.set('campaign_phone', phoneNumber);
  dynamicPhoneNumbers.forEach(function (ele) {
    ele.innerHTML = "<a class='campaign-phone-link' href='tel:".concat(formatPhoneNumber(phoneNumber), "'>\n    ").concat(formatPhoneNumber(phoneNumber, '-', isFormatted), "\n  </a>");
  });
};
export var getReferrerKeys = function getReferrerKeys(referrerInfo) {
  var referrerName = document.referrer;
  var lookupKeys = Object.keys(referrerInfo);
  var lookupReferrer = lookupKeys.find(function (element) {
    return referrerName.includes(element) === true;
  });

  var _ref = referrerInfo[lookupReferrer] || referrerInfo.default,
      _ref2 = _slicedToArray(_ref, 2),
      referrerCode = _ref2[0],
      referrerValue = _ref2[1];

  return [referrerCode, referrerValue];
};
export var dynamicQuoteApplyURL = function dynamicQuoteApplyURL(campaignID) {
  var referralData = ['421903', '421904', 'OSYIFP', '421905', '421906'];
  var domainName = location.hostname;
  var cid = 's037';
  var campaignMedium = cookie.get('campaignMedium');
  var campaignSource = cookie.get('campaignSource');
  var campaignPhone = cookie.get('campaign_phone');
  var campaignPID = cookie.get('campaignPID');
  var campaignEID = cookie.get('campaignEID');
  var addPID = campaignPID && !referralData.includes(campaignPID) ? "&PID=".concat(campaignPID) : '';
  var addEID = campaignEID && !referralData.includes(campaignEID) ? "&EID=".concat(campaignEID) : '';
  var linkList = {
    quoteSupplemental: {
      linkToFind: 'a[href*="cignasupplemental.expressenroll.com"]',
      linkParams: "cid=".concat(cid, "&campaign_id=").concat(campaignID),
      linkReplace: 'https://cignasupplemental.expressenroll.com/'
    },
    quoteDental: {
      linkToFind: 'a[href*="cignaindividual.com/public/Users/ExternalConnect.aspx"], a[href*="cignaindividual.com/public/Quoting/Individual/EnterQuoteCriteria.aspx"]',
      linkParams: "link_case=quote&campaign_id=".concat(campaignID, "&call=").concat(formatPhoneNumber(campaignPhone, '.')).concat(addPID),
      linkReplace: 'https://cignaindividual.com/public/Users/ExternalConnect.aspx'
    },
    quoteMedical: {
      linkToFind: 'a[href*="cignaindividual.com/public-ede"]',
      linkParams: "utm_source=".concat(campaignSource, "&utm_medium=").concat(campaignMedium, "&utm_campaign=").concat(campaignID, "&campaign_ID=").concat(campaignID, "&call=").concat(formatPhoneNumber(campaignPhone, '.'), "&_agent_id=cigna").concat(addPID).concat(addEID),
      linkReplace: 'https://cignaindividual.com/public-ede/'
    },
    quoteMedHealthSherpa: {
      linkToFind: 'a[href*="cigna.healthsherpa.com"]',
      linkParams: "utm_source=".concat(campaignSource, "&utm_medium=").concat(campaignMedium, "&utm_campaign=").concat(campaignID, "&campaign_ID=").concat(campaignID, "&call=").concat(formatPhoneNumber(campaignPhone, '.'), "&_agent_id=cigna").concat(addPID).concat(addEID),
      linkReplace: 'https://cigna.healthsherpa.com/'
    },
    quoteMedCignaShop: {
      linkToFind: 'a[href*="shopcigna.com"]',
      linkParams: "utm_source=".concat(campaignSource, "&utm_medium=").concat(campaignMedium, "&utm_campaign=").concat(campaignID, "&campaign_ID=").concat(campaignID, "&call=").concat(formatPhoneNumber(campaignPhone, '.'), "&_agent_id=cigna").concat(addPID).concat(addEID),
      linkReplace: 'https://shopcigna.com/'
    }
  };
  Object.keys(linkList).forEach(function (key) {
    var matchingLinks = document.querySelectorAll(linkList[key].linkToFind);
    [].forEach.call(matchingLinks, function (ele) {
      ele.setAttribute('href', "".concat(linkList[key].linkReplace, "?").concat(linkList[key].linkParams));
    });
  });

  if (domainName.match(/(campaigns.cigna.com)/gm)) {
    var campaignsLinks = ['cigna.com/individuals-families/health-wellness/', 'hiddenheroes.org/resource/cigna-national-veteran-support-line/', 'cigna.com/web/secure/consumer/coverage/eap', '/realsupport', 'cigna.com/web/secure/consumer/directory/telehealth'];
    var params = getParams(location.search);
    var paramString = Object.keys(params).map(function (key) {
      return "".concat(key, "=").concat(params[key]);
    }).join('&');
    campaignsLinks.forEach(function (link) {
      var linkToChange = document.querySelectorAll("a[href*=\"".concat(link, "\"]"));
      [].forEach.call(linkToChange, function (ele) {
        return ele.setAttribute('href', "".concat(ele.href, "?").concat(paramString));
      });
    });
  }
};